import { createPaginator } from "@orange-marmalade/paginate-this";
import { List } from "immutable";
import api from "APP_ROOT/api";
import createSearch from "MODULES/shared/actions/search";

const searchDiscrepancies = pageInfo => (dispatch, getState) => {
  const results = getState()
    .receivingRecordDetail.getIn(["receivingRecord", "discrepancies"], List())
    .toJS();
  const { limit, page } = pageInfo.query;
  const data = {
    total_count: results.length,
    results: results.slice(limit * page - limit, page * limit)
  };

  return Promise.resolve({ data });
};

export const receivingRecordsSearch = createSearch(
  "receivingRecords",
  api.receivingRecord.search
);

export default createPaginator({
  listId: receivingRecordsSearch.listId,
  fetch: receivingRecordsSearch.search
});

export const discrepancies = createPaginator({
  listId: "discrepancies",
  fetch: searchDiscrepancies,
  initialSettings: {
    pageSize: 5
  }
});



// WEBPACK FOOTER //
// ./app/modules/Receiving/pagination.js